interface TestPageProps {
  message?: string
  auth?: {
    user?: {
      id: number
      name: string
      email: string
      admin: boolean
      super_admin?: boolean
    } | null
  }
  flash?: {
    success?: string
    error?: string
    notice?: string
  }
}

export default function TestPage({ message, auth, flash }: TestPageProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="bg-card rounded-lg shadow-xl p-8 max-w-md w-full">
        <h1 className="text-3xl font-bold text-foreground mb-4">
          🎉 Inertia + React is Working!
        </h1>

        {message && (
          <p className="text-lg text-foreground mb-4">{message}</p>
        )}

        <div className="bg-green-50 border border-green-200 rounded-md p-4">
          <p className="text-green-800 font-medium">✅ Migration Successful</p>
          <ul className="mt-2 text-sm text-green-700 space-y-1">
            <li>• React 19 ✓</li>
            <li>• Inertia.js ✓</li>
            <li>• TypeScript ✓</li>
            <li>• Tailwind CSS v4 ✓</li>
            <li>• Vite HMR ✓</li>
          </ul>
        </div>

        {auth?.user && (
          <div className="mt-6 p-4 bg-blue-50 border border-blue-200 rounded-md">
            <p className="text-sm font-medium text-blue-900">
              Logged in as: {auth.user.name}
            </p>
            <p className="text-xs text-blue-700 mt-1">
              {auth.user.email}
            </p>
            {auth.user.admin && (
              <span className="inline-block mt-2 px-2 py-1 bg-blue-600 text-white text-xs rounded">
                Admin
              </span>
            )}
          </div>
        )}

        {flash?.success && (
          <div className="mt-4 p-3 bg-green-100 border border-green-300 rounded text-green-800 text-sm">
            {flash.success}
          </div>
        )}

        {flash?.error && (
          <div className="mt-4 p-3 bg-red-100 dark:bg-red-900 border border-red-300 rounded text-red-800 dark:text-red-200 text-sm">
            {flash.error}
          </div>
        )}
      </div>
    </div>
  )
}
